<template>
  <main class="administracaoPainel">
    <header class="administracaoCabecalho">
      <div>
        <p>Configuração operacional</p>
        <h1>Administração</h1>
        <span>Gerencie usuários, planos e lançamentos financeiros.</span>
      </div>
    </header>

    <nav class="administracaoAbas" aria-label="Áreas administrativas">
      <button
        type="button"
        :class="{ ativo: abaSelecionada == 'usuarios' }"
        @click="trocarAba('usuarios')"
      >
        <i class="fa fa-users" aria-hidden="true"></i>
        Usuários
      </button>
      <button
        v-if="retornaSite() !== 'Stream1x2'"
        type="button"
        :class="{ ativo: abaSelecionada == 'planos' }"
        @click="trocarAba('planos')"
      >
        <i class="fa fa-list-alt" aria-hidden="true"></i>
        Planos
      </button>
      <button
        type="button"
        :class="{ ativo: abaSelecionada == 'planos-lancamentos' }"
        @click="trocarAba('planos-lancamentos')"
      >
        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
        Lançamentos de planos
      </button>
      <button
        v-if="retornaSite() !== '7live' && retornaSite() !== 'Stream1x2'"
        type="button"
        :class="{ ativo: abaSelecionada == 'pay-admin' }"
        @click="trocarAba('pay-admin')"
      >
        <i class="fa fa-money" aria-hidden="true"></i>
        Pay
      </button>
      <button
        v-if="retornaSite() == '7live'"
        type="button"
        :class="{ ativo: abaSelecionada == 'creditos-lancamentos' }"
        @click="trocarAba('creditos-lancamentos')"
      >
        <i class="fa fa-credit-card" aria-hidden="true"></i>
        Lançamentos de créditos
      </button>
      <button
        v-if="retornaSite() == '7live'"
        type="button"
        :class="{ ativo: abaSelecionada == 'eventos-lancamentos' }"
        @click="trocarAba('eventos-lancamentos')"
      >
        <i class="fa fa-calendar" aria-hidden="true"></i>
        Lançamentos de eventos
      </button>
      <button
        v-if="retornaSite() == '7live'"
        type="button"
        :class="{ ativo: abaSelecionada == 'planos-finalizados' }"
        @click="trocarAba('planos-finalizados')"
      >
        <i class="fa fa-percent" aria-hidden="true"></i>
        Comissão
      </button>
    </nav>

    <section class="administracaoConteudo">
      <div v-show="abaSelecionada == 'usuarios'">
        <ListUsuarios />
      </div>
      <div v-show="abaSelecionada == 'planos'">
        <ListPlanos />
      </div>
      <div v-show="abaSelecionada == 'creditos-lancamentos'">
        <ListCreditosUsuario ref="listCreditosUsuario" :propView="'completo'" />
      </div>
      <div
        v-show="abaSelecionada == 'planos-lancamentos'"
        class="administracaoAbaComFiltros"
      >
        <ListPlanosCliente ref="listPlanosCliente" :propView="'completo'" />
      </div>
      <div v-show="abaSelecionada == 'eventos-lancamentos'">
        <ListEventosUsuario ref="listEventosUsuario" :propView="'completo'" />
      </div>
      <div v-show="abaSelecionada == 'planos-finalizados'">
        <ListPlanosFinalizados ref="listPlanosFinalizados" :propView="'completo'" />
      </div>
      <div
        v-show="abaSelecionada == 'pay-admin'"
        class="administracaoAbaComFiltros"
      >
        <ListPayAdmin ref="listPayAdmin" :propView="'completo'" />
      </div>
    </section>
  </main>
</template>

<script>
import ListUsuarios from "../lists/ListUsuarios";
import ListPlanos from "../lists/ListPlanos";
import ListPlanosCliente from "../lists/ListPlanosCliente";
import ListPayAdmin from "../lists/ListPayAdmin";
import ListPlanosFinalizados from "../lists/ListPlanosFinalizados";
import ListCreditosUsuario from "../lists/ListCreditosUsuario";
import ListEventosUsuario from "../lists/ListEventosUsuario";


export default {
  name: "Administracao",
  components: { ListPayAdmin, ListUsuarios, ListPlanos, ListPlanosCliente,ListPlanosFinalizados, ListCreditosUsuario, ListEventosUsuario },
  methods: {
    trocarAba(aba) {

      if(aba == "creditos-lancamentos")
      {
        this.$refs.listCreditosUsuario.carregarItens();    
      }else if(aba == "planos-lancamentos")
      {
        this.$refs.listPlanosCliente.carregarItens();
      }else if(aba == "eventos-lancamentos")
      {
        this.$refs.listEventosUsuario.carregarItens();
      }else if(aba == "planos-finalizados"){
        this.$refs.listPlanosFinalizados.carregarItens();
      }else if(aba == "pay-admin"){
        this.$refs.listPayAdmin.carregarItens();
      }

      this.abaSelecionada = aba;
    },
    retornaSite()
    {
      return this.$site;
    }
  },
  data: function () {
    return {
      abaSelecionada: "resumo",
      isAdmin:false
    };
  },
  async mounted(){

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";
    this.abaSelecionada = "usuarios";

  }
};
</script>

<style>
.administracaoPainel {
  margin: 0 auto;
  max-width: 1180px;
  padding: 26px 16px 48px;
  text-align: left;
}

.administracaoCabecalho {
  border-bottom: 1px solid #dfe3e6;
  padding: 0 2px 15px;
}

.administracaoCabecalho p {
  color: #65717a;
  font-size: 10px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: uppercase;
}

.administracaoCabecalho h1 {
  color: #242a2f;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.1;
  margin: 0;
}

.administracaoCabecalho span {
  color: #6f7880;
  display: block;
  font-size: 11px;
  margin-top: 6px;
}

.administracaoAbas {
  border-bottom: 1px solid #d9dee2;
  display: flex;
  overflow-x: auto;
  padding: 8px 2px 0;
}

.administracaoAbas button {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  color: #68727a;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  height: 38px;
  padding: 0 13px;
  white-space: nowrap;
}

.administracaoAbas button:hover {
  background: #f5f6f7;
  color: #30373d;
}

.administracaoAbas button.ativo {
  border-bottom-color: #e3ad55;
  color: #293138;
}

.administracaoAbas button:focus-visible {
  background: #eef1f3;
  outline: 0;
}

.administracaoConteudo {
  padding-top: 2px;
}

.administracaoAbaComFiltros {
  padding-top: 14px;
}

.administracaoConteudo .usuariosPainel {
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 767px) {
  .administracaoPainel {
    padding: 18px 8px 36px;
  }

  .administracaoCabecalho h1 {
    font-size: 22px;
  }

  .administracaoAbas button {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
